if($('footer#footer').length){
    $('footer#footer .footer-bottom').insertAfter('footer#footer')
    $('#signature').append('<span class="sigantureFirm"> | <a href="https://www.shopcode.cz/" target="_blank">ShopCode</a> | <a href="https://www.d2solutions.cz/" target="_blank">D2solutions</a></span>')

}